import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map, mapTo } from 'rxjs/operators';
import { PagedResponse } from '../core';
import { CreateRefundRequest, ListRefundsRequest, RefundApiService } from '@vendasta/billing';
import { reasonToApi, Refund, refundFromApi, RefundReason } from './refund';

@Injectable({ providedIn: 'root' })
export class RefundService {
  constructor(private refundApiService: RefundApiService) {}

  create(
    merchantId: string,
    chargeId: string,
    amount: number,
    reason: RefundReason,
    description: string,
  ): Observable<null> {
    const request = new CreateRefundRequest({
      merchantId: merchantId,
      paymentId: chargeId,
      amount: amount,
      reason: reasonToApi(reason),
      description: description,
    });
    return this.refundApiService.create(request).pipe(catchError(this.handleError), mapTo(null));
  }

  list(merchantId: string, paymentIds: string[], cursor: string, pageSize: number): Observable<PagedResponse<Refund>> {
    const req = new ListRefundsRequest({
      paymentIds: paymentIds,
      cursor: cursor,
      pageSize: pageSize,
      merchantId: merchantId,
    });
    return this.refundApiService.list(req).pipe(
      map((response) => {
        const refunds = (response.refunds || []).map((item) => refundFromApi(item));
        return new PagedResponse(refunds, response.nextCursor, response.hasMore);
      }),
    );
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    if (error.error instanceof ErrorEvent) {
      console.error(`An error occurred:`, error.error.message);
    } else {
      console.error(`Server returned ${error.message}`);
    }

    return observableThrowError(`Unable to issue a refund`);
  }
}
